export default "__VITE_ASSET__CZVr43zZ__"